import {createApp} from 'vue';
import {createPinia} from "pinia";
import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import {
  faArrowLeft,
  faArrowDown,
  faArrowRight,
  faBars,
  faBell,
  faCalendar,
  faCalendarCheck,
  faCalendarXmark,
  faCartShopping,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleDollarToSlot,
  faCirclePlus,
  faCircleQuestion,
  faClipboardList,
  faClock,
  faCloud,
  faCube,
  faDatabase,
  faDog,
  faCat,
  faEnvelope,
  faEnvelopeOpen,
  faEye,
  faEyeSlash,
  faFaceSmile,
  faFire,
  faFlag,
  faFolderOpen,
  faFolderTree,
  faFontAwesomeFlag,
  faGear,
  faGift,
  faGlobe,
  faHandHolding,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHeartPulse,
  faKey,
  faList,
  faLocationDot,
  faNotesMedical,
  faPaw,
  faPencil,
  faPhone,
  faPieChart,
  faPlayCircle,
  faPlus,
  faPrescriptionBottleMedical,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faRectangleList,
  faRotate,
  faSave,
  faSearch,
  faShoppingCart,
  faStar,
  faStopCircle,
  faSyringe,
  faTable,
  faTimes,
  faTrash,
  faTruckRampBox,
  faUser,
  faUserCircle,
  faUsers,
  faXmark,
  faBox,
  faBoxesStacked,
  faAddressCard,
  faAward,
} from "@fortawesome/free-solid-svg-icons";
import { faBuilding } from '@fortawesome/free-regular-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Toast from 'vue-toastification';
import App from '@/app/App.vue';
import Modal from "@/shared/components/ModalComponent.vue";
import router from '@/router/router.ts';
import i18n from "@/shared/i18n/i18n";
import loggerInstance from "@/shared/utils/logger.ts";
import 'vue-toastification/dist/index.css';
import '@/app/styles/main.css';

// Add icons to the library
library.add(
  faArrowLeft,
  faArrowDown,
  faArrowRight,
  faBars,
  faBell,
  faCalendar,
  faCalendarCheck,
  faCalendarXmark,
  faCartShopping,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleDollarToSlot,
  faCirclePlus,
  faCircleQuestion,
  faClipboardList,
  faClock,
  faCloud,
  faCube,
  faDatabase,
  faDog,
  faCat,
  faEnvelope,
  faEnvelopeOpen,
  faEye,
  faEyeSlash,
  faFaceSmile,
  faFire,
  faFlag,
  faFolderOpen,
  faFolderTree,
  faFontAwesomeFlag,
  faGear,
  faGift,
  faGlobe,
  faHandHolding,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHeartPulse,
  faKey,
  faList,
  faLocationDot,
  faNotesMedical,
  faPaw,
  faPencil,
  faPhone,
  faPieChart,
  faPlayCircle,
  faPlus,
  faPrescriptionBottleMedical,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faRectangleList,
  faRotate,
  faSave,
  faSearch,
  faShoppingCart,
  faStar,
  faStopCircle,
  faSyringe,
  faTable,
  faTimes,
  faTrash,
  faTruckRampBox,
  faUser,
  faUserCircle,
  faUsers,
  faXmark,
  faBox,
  faBoxesStacked,
  faAddressCard,
  faAward,
  faBuilding,
  faWhatsapp,
);

// Create Pinia instance
const pinia = createPinia();

// Create Vue app
const app = createApp(App);

// Register the logger globally
app.config.globalProperties.$logger = loggerInstance;

// Register the FontAwesome library globally
app.component('font-awesome-icon', FontAwesomeIcon);

// Register Pinia, Router, i18n, Toast
app.use(pinia); // <- Ensure this is used before mounting the app
app.use(router);
app.use(i18n);
app.use(Toast, {
  position: 'bottom-right',
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.4,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: true,
  rtl: false
});

app.component('Modal', Modal);

// Datepicker
app.use(VueTailwindDatepicker);

// Mount the app
app.mount('#app');
